import { ptBR } from '@/i18n/pt-BR';
import type { EscritoriosErrorReason } from '@/lib/escritorios';

const _MEMBERS_REASON_MAP: Record<EscritoriosErrorReason, string> = {
  conflict: ptBR.members.errorConflict,
  owner_required: ptBR.members.errorOwnerRequired,
  owner_cannot_be_removed: ptBR.members.errorOwnerCannotBeRemoved,
  not_found: ptBR.members.errorNotFound,
  validation: ptBR.members.errorValidation,
  escritorio_update_empty: ptBR.members.errorValidation,
  user_has_no_escritorio: ptBR.members.errorValidation,
  network: ptBR.members.errorNetwork,
  unauthorized: ptBR.members.errorUnauthorized,
  unknown: ptBR.members.errorGeneric,
};

const _ESCRITORIO_REASON_MAP: Record<EscritoriosErrorReason, string> = {
  owner_required: ptBR.escritorio.errorOwnerRequired,
  escritorio_update_empty: ptBR.escritorio.errorEmpty,
  validation: ptBR.escritorio.errorValidation,
  user_has_no_escritorio: ptBR.escritorio.errorValidation,
  network: ptBR.escritorio.errorNetwork,
  unauthorized: ptBR.escritorio.errorUnauthorized,
  not_found: ptBR.escritorio.errorGeneric,
  conflict: ptBR.escritorio.errorGeneric,
  owner_cannot_be_removed: ptBR.escritorio.errorGeneric,
  unknown: ptBR.escritorio.errorGeneric,
};

export function mapMembersErrorReason(reason: EscritoriosErrorReason): string {
  return _MEMBERS_REASON_MAP[reason];
}

export function mapEscritorioErrorReason(reason: EscritoriosErrorReason): string {
  return _ESCRITORIO_REASON_MAP[reason];
}
